import { render, staticRenderFns } from "./CommunicationTagSettings.vue?vue&type=template&id=2a13802e&scoped=true"
import script from "./CommunicationTagSettings.vue?vue&type=script&lang=ts"
export * from "./CommunicationTagSettings.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationTagSettings.vue?vue&type=style&index=0&id=2a13802e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13802e",
  null
  
)

export default component.exports